import React, { useEffect, useState } from "react";

import ColorLabel from "../ColorLabels/ColorLabels";
import {
  MapDescriptionInputType,
  ShutdownTypesType,
} from "./MapDescriptionTypes";

function MapDescription({
  shutdown_types,
  display_type,
  placeholder,
}: MapDescriptionInputType) {
  const [allShutdownTypes, setAllShutdownTypes] = useState<ShutdownTypesType>(
    [],
  );

  useEffect(() => {
    let a = structuredClone(shutdown_types);
    a.push({
      id: 0,
      color: "#BCBBBC",
      name: placeholder,
      map_priority: 1,
      display_type: 1,
    });
    setAllShutdownTypes(a);
  }, [shutdown_types, placeholder]);

  return (
    <div className="flex flex-row flex-wrap my-8 mb-0 justify-start md:justify-center">
      {allShutdownTypes.map((shutdown_type) => {
        if (shutdown_type.display_type === display_type) {
          return (
            <div className="mr-12" key={shutdown_type.id}>
              <ColorLabel
                font_size={16}
                color={shutdown_type.color}
                text={shutdown_type.name}
              />
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}

export default MapDescription;
